exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Footer__footer___1UphA {\n  font-size: 12px;\n  text-align: center;\n  padding-bottom: 24px;\n}\n\n.Footer__footer___1UphA:before,\n.Footer__footer___1UphA:after {\n  content: '\\2764';\n  color: #8c9fed !important;\n  margin: 0 4px;\n}\n", ""]);

// exports
exports.locals = {
	"footer": "Footer__footer___1UphA"
};